<h3>Cancelar Interrupção de Férias</h3>
<a href="#" class="sr-only">Cancelar Interrupção de Férias</a>

<style>
    @media (max-width: 960px) {
        div.p-tooltip-top > div.p-tooltip-text {
            margin-top: -10px !important;
            margin-bottom: -10px !important;
        }
        div.p-tooltip-arrow {
            display: none;
        }
    }
</style>

<app-cabecalho-funcional [exercicioSelecionado]="exercicioSelecionado" [exibirPeriodoProgramacaoDisponivel]="true" [exibirTipoPeriodoAquisitivo]="false"></app-cabecalho-funcional>
<div class="row">
    <div class="col-sm-12">
        <ng-container *ngFor="let parcela of parcelasFeriasParaCancelarInterrupcao; let i = index">
            <h4 style="color: var(--active)">{{ parcela.ordem + (parcela.geracao > 0 ? "." + parcela.geracao : "") }}ª Parcela</h4>
            <div class="br-card">
                <div class="row" style="margin-left: 0px; margin-right: 0px">
                    <div class="col-12 col-lg-2 mt-2">
                        <label [for]="'campo-data-inicio_' + i">Período de Férias</label>
                        <br />
                        <p class="mb-0">
                            {{ parcela.dataInicio | dataFormatada }} a
                            {{ parcela.dataFim | dataFormatada }}
                        </p>
                    </div>
                    <div class="col-12 col-lg-2 mt-2">
                        <label [for]="'campo-quantidade-dias_' + i">Quantidade de dias</label>
                        <p class="mb-0">{{ parcela.quantidadeDias }}</p>
                    </div>
                    <div class="col-12 col-lg-2 mt-2 desktop-only">
                        <label>Situação</label>
                        <br />
                        <p-tag [value]="parcela.situacao.descricao" styleClass="text" [style]="{ background: 'linear-gradient(' + parcela.situacao.codigoCor + ' 100%,' + parcela.situacao.codigoCor + ' 100%)' }"></p-tag>
                    </div>
                </div>
                <div class="row" style="margin-left: 0px; margin-right: 0px">
                    <div class="col-12 col-lg-2 mt-2">
                        <p class="label mb-1">Adicionais de Férias</p>
                        <p class="mb-0" *ngIf="parcela.adiantamentoDecimoTerceiro.valor">Adiantamento 13º</p>
                        <p class="mb-0" *ngIf="parcela.adiantamentoSalarial.valor">Adiantamento Salarial</p>
                        <p class="mb-0" *ngIf="parcela.abonoPecuniario.valor">Abono Pecuniário</p>
                        <p class="mb-0" *ngIf="!parcela.adiantamentoDecimoTerceiro.valor && !parcela.adiantamentoSalarial.valor && !parcela.abonoPecuniario.valor">Não solicitado</p>
                    </div>
                    <div class="col-12 col-lg-2 mt-2 br-input" *ngIf="parcela.adiantamentoSalarial.valor">
                        <p class="label mb-1">Parcelas de Desconto</p>
                        <p class="mb-0">{{ parcela.parcelasDesconto }}</p>
                    </div>
                </div>
                <div class="row mobile-only" style="margin-left: 0px; margin-right: 0px">
                    <div class="col-12 col-lg-12 mt-2">
                        <label>Situação</label>
                        <br />
                        <p-tag [value]="parcela.situacao.descricao" styleClass="text" [style]="{ background: 'linear-gradient(' + parcela.situacao.codigoCor + ' 100%,' + parcela.situacao.codigoCor + ' 100%)' }"></p-tag>
                    </div>
                </div>
                <div class="row" style="margin-left: 0px; margin-right: 0px" *ngIf="parcela.situacao.descricao === 'Interrompida'">
                    <div class="col-12 col-lg-4" style="padding-left: 0px !important; padding-right: 0px !important" *ngIf="parcela.dataInterrupcao || parcela.motivoLegal || parcela.documentoLegal || parcela.dataPublicacaoDocumentoLegal">
                        <div class="row" style="margin-left: 0px; margin-right: 0px" *ngIf="parcela.dataInterrupcao || parcela.motivoLegal">
                            <div class="col-12 col-lg-6 mt-2 br-input" *ngIf="parcela.dataInterrupcao">
                                <p class="label mb-1">Data da Interrupção</p>
                                <p class="mb-0">
                                    {{ parcela.dataInterrupcao | dataFormatada }}
                                </p>
                            </div>
                            <div class="col-12 col-lg-6 mt-2 br-input" *ngIf="parcela.motivoLegal">
                                <p class="label mb-1">Motivo Legal</p>
                                <p class="mb-0">{{ parcela.motivoLegal }}</p>
                            </div>
                        </div>
                        <div class="row" style="margin-left: 0px; margin-right: 0px" *ngIf="parcela.documentoLegal || parcela.dataPublicacaoDocumentoLegal">
                            <div class="col-12 col-lg-6 mt-2 br-input" *ngIf="parcela.documentoLegal">
                                <p class="label mb-1">Documento Legal</p>
                                <p class="mb-0">{{ parcela.documentoLegal }}</p>
                            </div>
                            <div class="col-12 col-lg-6 mt-2 br-input" *ngIf="parcela.dataPublicacaoDocumentoLegal">
                                <p class="label mb-1">Data da Publicação</p>
                                <p class="mb-0">
                                    {{ parcela.dataPublicacaoDocumentoLegal | dataFormatada }}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-8" style="padding-left: 0px !important; padding-right: 0px !important">
                        <div class="row" style="margin-left: 0px; margin-right: 0px" *ngIf="parcela.justificativaInterrupcao">
                            <div class="col-12 mt-2 br-input">
                                <p class="label mb-1">Justificativa de interrupção da parcela</p>
                                <p class="mb-0">{{ parcela.justificativaInterrupcao }}</p>
                            </div>
                        </div>
                        <div class="row" style="margin-left: 0px; margin-right: 0px" *ngIf="parcela.selecionadaParaCancelarInterrupcao">
                            <div class="col-6 mt-2 br-input">
                                <p class="label mb-1">
                                    Período de Férias Original
                                    <i aria-hidden="true" class="fas fa-info-circle text-interactive mb-1 desktop-only" pTooltip="Período de Férias da parcela antes de ter sido interrompida. Será retomado após o cancelamento da interrupção."></i>
                                    <i aria-hidden="true" class="fas fa-info-circle text-interactive mb-1 mobile-only" pTooltip="Período de Férias da parcela antes de ter sido interrompida. Será retomado após o cancelamento da interrupção." tooltipPosition="top" (touchstart)="onTooltipTouchStart($event)" (touchend)="onTooltipTouchEnd($event)"></i>
                                </p>
                                <p class="mb-0">
                                    {{ parcela.dataInicioOriginal | dataFormatada }} a
                                    {{ parcela.dataFimOriginal | dataFormatada }}
                                </p>
                            </div>
                            <div class="col-6 mt-2 br-input">
                                <p class="label mb-1">
                                    Quantidade de dias Original
                                    <i aria-hidden="true" class="fas fa-info-circle text-interactive mb-1 desktop-only" pTooltip="Quantidade de dias da parcela antes de ter sido interrompida. Será retomada após o cancelamento da interrupção."></i>
                                    <i aria-hidden="true" class="fas fa-info-circle text-interactive mb-1 mobile-only" pTooltip="Quantidade de dias da parcela antes de ter sido interrompida. Será retomada após o cancelamento da interrupção." tooltipPosition="top" (touchstart)="onTooltipTouchStart($event)" (touchend)="onTooltipTouchEnd($event)"></i>
                                </p>
                                <p class="mb-0">{{ parcela.quantidadeDiasOriginal }}</p>
                            </div>
                        </div>
                        <div class="row" style="margin-left: 0px; margin-right: 0px" *ngIf="parcela.selecionadaParaCancelarInterrupcao">
                            <div class="br-textarea col-12 mt-2" [ngClass]="{ danger: parcela.validacao.justificativaCancelamentoInterrupcaoInvalida }">
                                <label [for]="'textarea-justificativa-parcela_' + i">Justificativa de Cancelamento da Interrupção da parcela (Obrigatório)</label>
                                <textarea [id]="'textarea-justificativa-parcela_' + i" rows="6" cols="90" pInputTextarea autoResize="autoResize" style="width: 100%" maxlength="300" [(ngModel)]="parcela.justificativaCancelamentoInterrupcao" maxlength="300" (input)="onJustificativaCancelamentoInterrupcaoChange($event, parcela)" (blur)="validarJustificativaCancelamentoInterrupcao(parcela)"></textarea>
                                <div class="text-base mt-1">
                                    <span class="limit" aria-live="polite">
                                        <b>{{ parcela.justificativaCancelamentoInterrupcao.length }}</b>
                                        de
                                        <b>300</b>
                                        caracteres digitados
                                    </span>
                                    <span class="current" aria-live="polite" role="status" id="limitmax"></span>
                                </div>
                                <p class="mt-1" *ngIf="parcela.validacao.justificativaCancelamentoInterrupcaoInvalida">
                                    <span class="feedback danger" role="alert">
                                        <i class="fas fa-times-circle" aria-hidden="true"></i>
                                        {{ msgJustificativaObrigatoria }}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="parcela.podeCancelarInterrupcao && !parcela.selecionadaParaCancelarInterrupcao" style="margin-left: 0px; margin-right: 0px">
                    <div class="col-12 col-lg-12 mt-2 text-right">
                        <button [id]="'botao-interromper-parcela_' + i" pButton type="button" label="Cancelar Interrupção" class="botao-responsivo" (click)="selecionarParcelaParaCancelarInterrupcao(parcela)"></button>
                    </div>
                </div>
                <div class="row" *ngIf="parcela.podeCancelarInterrupcao && parcela.selecionadaParaCancelarInterrupcao" style="margin-left: 0px; margin-right: 0px">
                    <div class="col-12 col-lg-12 mt-2 text-right">
                        <button [id]="'botao-desistir-interromper-parcela_' + i" pButton type="button" label="Desistir" class="botao-responsivo" (click)="desistirSelecaoParcelaParaCancelarInterrupcao(parcela)"></button>
                    </div>
                </div>
                <div class="row" style="padding-bottom: 10px">
                    <!--padding-bottom-->
                </div>
            </div>
        </ng-container>
    </div>
</div>
<div class="row mt-2">
    <div class="col text-right">
        <button aria-label="botão voltar" id="botao-voltar" pButton type="button" label="Voltar" class="secondary mr-2 botao-responsivo" (click)="confirmarVoltar()"></button>
        <button aria-label="botão cancelar-interrupcao" id="botao-cancelar-interrupcao" pButton type="submit" label="Concluir" class="primary botao-responsivo" (click)="confirmarCancelamentoInterrupcao()"></button>
        <!--p-button (click)="showDialog()" icon="pi pi-external-link" label="Show"></p-button-->
    </div>
</div>
<p-confirmDialog key="confirmPadrao" acceptLabel="Sim" rejectLabel="Não"></p-confirmDialog>
